module.exports = __webpack_public_path__ + "media/Cheer.91f7b9d5.mp3";